import { Predicate } from '@angular/core'
import { invalidIndex } from './invalid-index'

export function findIndices<T>(
  predicate: Predicate<T>,
  existing: readonly T[]
): number[] {
  return existing.reduce((acc, it, i) => {
    const index = predicate(it) ? i : -1
    return invalidIndex(index) ? acc : [...acc, index]
  }, [] as number[])
}
